export type Plan = 'FREE' | 'PREMIUM'
export type BillingInterval = 'month' | 'year'

export interface PlanConfig {
  id: string
  name: string
  price: number
  priceDisplay: string
  currency: string
  interval: BillingInterval
  features: string[]
  reason: string
}

/**
 * Modelo de cobrança (jul/2026) — o site é PÚBLICO e grátis; o Premium são 5 funções.
 *
 * Grátis, sem login, sem limite, com anúncios:
 *   calculadoras, exportar PDF/imagem do resultado, comprovante COM marca,
 *   blog, profissões MEI, templates, glossário.
 *
 * Premium (R$ 8,90/mês) — e SÓ isto:
 *   1. Painel financeiro
 *   2. Orçamento mensal
 *   3. Registrar faturamento
 *   4. Comprovante limpo (banco/aluguel)
 *   5. Relatório pro contador + CSV + anexos
 *   (+ o site sem anúncios)
 *
 * Avulso R$ 6,90: 1 comprovante limpo sem assinar.
 *
 * REGRA: nada fora dessa lista pode ser gateado, e nenhuma copy pode prometer
 * essas 5 coisas no plano grátis. Já aconteceu — e o site inteiro ficou mentindo.
 */
export const PLANS: Record<Plan, PlanConfig> = {
  FREE: {
    id: 'free',
    name: 'Gratuito',
    price: 0,
    priceDisplay: 'R$ 0',
    currency: 'BRL',
    interval: 'month',
    reason: '',
    features: [
      'Todas as calculadoras, sem limite e sem login',
      'Exportar PDF e imagem do resultado, sem limite',
      'Comprovante de faturamento (versão com marca)',
      'Blog, profissões MEI, templates e glossário',
    ],
  },
  PREMIUM: {
    id: 'premium',
    name: 'Premium',
    price: 8.9,
    priceDisplay: 'R$ 8,90',
    currency: 'BRL',
    interval: 'month',
    reason: 'Calcula MEI - Premium',
    features: [
      'Painel financeiro completo (teto, DAS, mês a mês)',
      'Orçamento e planejamento mensal',
      'Registrar faturamento e despesas',
      'Comprovante de faturamento LIMPO — o que banco e imobiliária aceitam',
      'Relatório pro contador, importação CSV e anexos',
      'Sem anúncios em todo o site',
    ],
  },
}

/**
 * Compra avulsa: 1 comprovante limpo (sem assinatura).
 *
 * Preço ancorado ABAIXO de um mês de Premium (R$ 8,90) de propósito: o avulso é
 * micro-compra por impulso (quem precisa de UM comprovante agora); ficar abaixo
 * do Premium mantém o funil coerente — quem vai precisar de novo migra pro
 * Premium (ilimitado + painel) por quase o mesmo valor. Era R$ 14,90 (mais caro
 * que o Premium/mês, uma inversão que travava a compra); revisado em jul/2026.
 */
export const AVULSO_COMPROVANTE = {
  id: 'comprovante_limpo',
  name: '1 comprovante limpo',
  price: 6.9,
  priceDisplay: 'R$ 6,90',
  currency: 'BRL',
  credits: 1,
  reason: 'Calcula MEI — 1 comprovante de faturamento limpo',
} as const

/*
 * REMOVIDOS em jul/2026 (não recriar sem decisão de produto):
 *   FREE_HISTORY_MONTHS   — histórico de 6 meses no FREE; o painel inteiro é Premium.
 *   EXPORTS_PER_MONTH     — cota de 5 exports/mês; exportar cálculo agora é livre.
 *   COMPROVANTES_PER_MONTH— cota do comprovante COM marca; a isca não se limita.
 */

export function getPlan(plan: Plan): PlanConfig {
  return PLANS[plan]
}

export function getPriceDisplay(plan: Plan): string {
  return PLANS[plan].priceDisplay
}
